import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Datepicker from 'react-datepicker';
import Popover from 'react-awesome-popover';
import * as moment from 'moment';
import 'moment/locale/de';
import {CountryDropdown} from "react-country-region-selector";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

class SupporterDetailsBlock extends Component {

    constructor(props) {
        super(props);

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.reloadSupporter = this.reloadSupporter.bind(this);
        this.handleCountryInput = this.handleCountryInput.bind(this);
    }

    componentDidMount() {
        this.props.getSupporter(this.props.supporterId);
    }

    reloadSupporter() {
        this.props.getSupporter(this.props.supporterId);
    }

    handleFormSubmit(e) {
        e.preventDefault();
        let {supporterDetails} = this.props;
        this.props.handleFormSubmit(supporterDetails);
    }
    convertCountryValue(country) {
        if (country !== null) {
            return country.substring(0, 2).toUpperCase();
        }
        return null;
    };

    handleCountryInput(country){
        let cl = country.toLowerCase();
        this.props.handleTextInputChange({target: {name: 'country', value: cl + '_' + country}});
    };

    getCountryName = (code) => {
        const countryCode = code?.split("_")[1]?.toUpperCase();
        return countries.getName(countryCode, "en");
    }


    render() {
        const {t, supporterDetails} = this.props;
        return (
            <div className="ibox SupporterDetailsBlock">
                <form className="form-inline-edit" onSubmit={this.handleFormSubmit}>
                    <div className="ibox-title">
                        <h5>{t('supporterScreen.supporterDetails.title')}</h5>
                        <div className="ibox-tools">
                            {supporterDetails.edit ? (
                                <div>
                                    <a onClick={this.reloadSupporter} className="btn btn-default m-r-xs">
                                        <i className="fa fa-undo"/>
                                    </a>
                                    <button type="submit" className="btn btn-primary"
                                            disabled={supporterDetails.loading}>
                                        {supporterDetails.loading ? (
                                            <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                        ) : null}
                                        <i className="fa fa-save"/>
                                    </button>
                                </div>
                            ) : (
                                <a onClick={this.props.editSupporter}>
                                    <i id="editSupporterDetailsButton" className="fa fa-pencil fa-1-5x"/>
                                </a>
                            )}
                        </div>
                    </div>
                    <div className="ibox-content">
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.lastname) ? ' has-error' : '')}>
                                    <label>{t('supporterDetails.lastname.label')}</label>
                                    <input className="form-control" name="lastname" value={supporterDetails.lastname || ''}
                                           readOnly={!supporterDetails.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                    {(supporterDetails.errors && supporterDetails.errors.lastname) ? (
                                        <span className="help-block">
                                            {t('supporterDetails.lastname.error.' + supporterDetails.errors.lastname)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.firstname) ? ' has-error' : '')}>
                                    <label>{t('supporterDetails.firstname.label')}</label>
                                    <input className="form-control" name="firstname" value={supporterDetails.firstname || ''}
                                           readOnly={!supporterDetails.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                    {(supporterDetails.errors && supporterDetails.errors.firstname) ? (
                                        <span className="help-block">
                                            {t('supporterDetails.firstname.error.' + supporterDetails.errors.firstname)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <div className="form-group">
                                    <label>{t('supporterDetails.nickname.label')}</label>
                                    <input className="form-control" name="nickname"
                                           value={supporterDetails.nickname || ''}
                                           readOnly={!supporterDetails.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div className="form-group">
                                    <label>{t('supporterDetails.pronoun.label')}</label>
                                    {!supporterDetails.edit ? (
                                        <input className="form-control" name="pronoun"
                                               value={supporterDetails.pronoun ? (supporterDetails.pronoun === 'OTHERS' ? (supporterDetails.pronounOthers || '') : t('supporterDetails.pronoun.' + supporterDetails.pronoun)) : ''}
                                               readOnly={true}/>
                                    ) : (
                                        <div>
                                            <select className="form-control" name="pronoun"
                                                    value={supporterDetails.pronoun || ''}
                                                    onChange={this.props.handleTextInputChange}>
                                                <option value="">-</option>
                                                {['SHE', 'HE', 'THEY', 'NONE', 'OTHERS'].map((pronoun) => (
                                                    <option value={pronoun} key={pronoun}>
                                                        {t('supporterDetails.pronoun.' + pronoun)}
                                                    </option>
                                                ))}
                                            </select>
                                            {supporterDetails.pronoun === 'OTHERS' ? (
                                                <input className="form-control m-t-xs" name="pronounOthers"
                                                       value={supporterDetails.pronounOthers || ''}
                                                       placeholder={t('supporterDetails.pronoun.OTHERS')}
                                                       onChange={this.props.handleTextInputChange}/>
                                            ) : null}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.email) ? ' has-error' : '')}>
                                    <label>{t('supporterDetails.email.label')}</label>
                                    <input className="form-control" name="email" value={supporterDetails.email}
                                           readOnly={!supporterDetails.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                    {(supporterDetails.errors && supporterDetails.errors.email) ? (
                                        <span className="help-block">
                                            {t('supporterDetails.email.error.' + supporterDetails.errors.email)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.phone) ? ' has-error' : '')}>
                                    <label>{t('supporterDetails.phone.label')}</label>
                                    <input className="form-control" name="phone" value={supporterDetails.phone}
                                           readOnly={!supporterDetails.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                    {(supporterDetails.errors && supporterDetails.errors.phone) ? (
                                        <span className="help-block">
                                            {t('supporterDetails.phone.error.' + supporterDetails.errors.phone)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.zipcode) ? ' has-error' : '')}>
                                    <label>{t('supporterDetails.zipcode.label')}</label>
                                    <input className="form-control" name="zipcode" value={supporterDetails.zipcode}
                                           readOnly={!supporterDetails.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                    {(supporterDetails.errors && supporterDetails.errors.zipcode) ? (
                                        <span className="help-block">
                                            {t('supporterDetails.zipcode.error.' + supporterDetails.errors.zipcode)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.city) ? ' has-error' : '')}>
                                    <label>{t('supporterDetails.city.label')}</label>
                                    <input className="form-control" name="city" value={supporterDetails.city}
                                           readOnly={!supporterDetails.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                    {(supporterDetails.errors && supporterDetails.errors.city) ? (
                                        <span className="help-block">
                                            {t('supporterDetails.city.error.' + supporterDetails.errors.city)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                  className={"form-group"}>
                                    <label>{t('supporterDetails.country.label')}</label>
                                    {!supporterDetails.edit ? (
                                        <input className="form-control" name="country"
                                               value={this.getCountryName(supporterDetails.country)}
                                               readOnly={true}/>
                                            ) : (
                                        <CountryDropdown
                                            priorityOptions={['DE']}
                                            value={this.convertCountryValue(supporterDetails.country)}
                                            onChange={this.handleCountryInput}
                                            valueType='short'
                                            className='form-control'
                                        />
                                        )}
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.birthday) ? ' has-error' : '')}>
                                    <label>{t('supporterDetails.birthday.label')}</label>
                                    {!supporterDetails.edit ? (
                                        <input className="form-control" name="birthday"
                                               value={supporterDetails.birthday}
                                               readOnly={true}/>
                                    ) : (
                                        <Datepicker
                                            selected={supporterDetails.birthday ? moment(supporterDetails.birthday, 'DD.MM.YYYY') : moment().subtract(25, 'year')}
                                            dateFormat="DD.MM.YYYY" showYearDropdown locale={moment.locale('de')}
                                            dropdownMode="select" className="form-control"
                                            minDate={moment().subtract(100, 'years')}
                                            maxDate={moment().subtract(16, 'years')}
                                            value={supporterDetails.birthday}
                                            onSelect={this.props.handleBirthdayChange}/>
                                    )}

                                    {(supporterDetails.errors && supporterDetails.errors.birthday) ? (
                                        <span className="help-block">
                                            {t('supporterDetails.birthday.error.' + supporterDetails.errors.birthday)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.handycap) ? ' has-error' : '')}>
                                    <label>{t('supporterDetails.handycap.label')}</label>
                                    <input className="form-control" name="handycap" value={supporterDetails.handycap}
                                           readOnly={!supporterDetails.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                    {(supporterDetails.errors && supporterDetails.errors.handycap) ? (
                                        <span className="help-block">
                                            {t('supporterDetails.handycap.error.' + supporterDetails.errors.handycap)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        {supporterDetails.edit ? (
                            <div className="row">
                                <div className="col-xs-6">
                                    <div
                                        className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.setNewPassword) ? ' has-error' : '')}>
                                        <div className="checkbox checkbox-default">
                                            <input type="checkbox" name="setNewPassword" id="supporterDetails-setNewPassword-checkbox" checked={supporterDetails.setNewPassword}
                                                   onChange={this.props.handleCheckboxChange}/>
                                            <label htmlFor="supporterDetails-setNewPassword-checkbox">{t('supporterDetails.setNewPassword.label')}</label>
                                        </div>
                                        {(supporterDetails.errors && supporterDetails.errors.setNewPassword) ? (
                                            <span className="help-block">
                                            {t('supporterDetails.setNewPassword.error.' + supporterDetails.errors.setNewPassword)}
                                        </span>
                                        ) : null}
                                    </div>
                                </div>
                                {supporterDetails.setNewPassword ? (
                                    <div className="col-xs-6">
                                        <div
                                            className={"form-group" + ((supporterDetails.errors && supporterDetails.errors.newPassword) ? ' has-error' : '')}>
                                            <label>{t('supporterDetails.newPassword.label')}</label>
                                            <input className="form-control" name="newPassword" value={supporterDetails.newPassword}
                                                   onChange={this.props.handleTextInputChange}/>
                                            {(supporterDetails.errors && supporterDetails.errors.newPassword) ? (
                                                <span className="help-block">
                                            {t('supporterDetails.newPassword.error.' + supporterDetails.errors.newPassword)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-xs-12">
                                    <Popover contentClass="rap-popover-content">
                                        <a>{t('supporterDetails.applicationInfo')}</a>
                                        <div className="p-md" style={{width: 400}}>
                                            <strong>
                                                {t('applicationScreen.application.firstFusionYear')}
                                            </strong><br/>
                                            {supporterDetails.firstFusionYear}
                                            <br/><br/>
                                            <strong>
                                                {t('applicationScreen.application.previousWorkType')}
                                            </strong><br/>
                                            {supporterDetails.previousWorkType ? supporterDetails.previousWorkType.name : ''}
                                            <br/><br/>
                                            <strong>
                                                {t('applicationScreen.application.application')}
                                            </strong><br/>
                                            {supporterDetails.application}
                                        </div>
                                    </Popover>
                                </div>
                            </div>
                        )}
                    </div>
                </form>
            </div>
        )
    }
}

export default translate()(SupporterDetailsBlock);